<div class="toolbar">
  <button mat-icon-button aria-hidden="false" title="Carica" (click)="iconClick('upload')" [disabled]="!activeNode?.id || moveFiletoggle">
    <mat-icon>upload</mat-icon>
    <input class="d-none" type="file" name="" id="" #fileUpload (click)="cleanInput($event)" (input)="uploadFile($event)" />
  </button>

  <button mat-icon-button aria-hidden="true" title="Scarica" (click)="iconClick('download')" [disabled]="moveFiletoggle || !activeToolbarAction">
    <mat-icon>download</mat-icon>
  </button>

  <button mat-icon-button aria-hidden="true" title="Sposta" (click)="iconClick('move')" [disabled]="!activeToolbarAction">
    <mat-icon>open_with</mat-icon>
  </button>

  <button
    *ngIf="!(selectedNodes[0]?.type === 'folder'); else deleteFolder"
    mat-icon-button
    aria-hidden="true"
    title="Elimina"
    (click)="iconClick('delete')"
    [disabled]="moveFiletoggle || !activeToolbarAction"
  >
    <mat-icon>delete</mat-icon>
  </button>

  <!-- <button mat-button aria-hidden="true" (click)="iconClick('select_all')" [disabled]="moveFiletoggle">
    <mat-icon>checklist</mat-icon>
    <span class="m-2">Seleziona tutti</span>
  </button> -->
</div>

<ng-template #deleteFolder>
  <button mat-icon-button aria-hidden="true" title="Elimina" (click)="iconClick('delete')" *ngIf="selectedNodes[0]?.isDeletable">
    <mat-icon>delete</mat-icon>
  </button>
</ng-template>
